import CryptoJS from 'crypto-js'

// 加密
const encrypt = (text,iv,key) => {
  var encrypted = CryptoJS.AES.encrypt(text,
    CryptoJS.enc.Base64.parse(key), {
      iv: CryptoJS.enc.Base64.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
  var tag = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  console.log(tag)
  return tag
}

// 解密
const decrypt = (text,iv,key) => {
  var decryptResult = CryptoJS.AES.decrypt(text,
    CryptoJS.enc.Base64.parse(key), { // AES解密
      iv: CryptoJS.enc.Base64.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
  var resData = decryptResult.toString(CryptoJS.enc.Utf8).toString();
  console.log(resData)
  return resData
}

let cryptojs = {
  encrypt: encrypt,
  decrypt: decrypt
}
export default cryptojs



// WEBPACK FOOTER //
// ./src/config/util.js